// extracted by mini-css-extract-plugin
export var editButton = "_kr-0";